import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "form-activator",
  templateUrl: "./form-activator.component.html",
})
export class FormActivatorComponent {

  @Input() public form: any;
  @Output() public activateFormEvent = new EventEmitter();

  public activateForm() {
    if (this.form) {
      this.activateFormEvent.emit(this.form.active);
    }
  }

}
